import axios from 'axios';

/*
*  This file contains all axios calls related to create dashboard widget on CB
*/

const BASE_URL = '/app/funnelGadget';

export const getFunnelGadgetGoals = async (publishedXml) => {
    const { data } = await axios.put(`${BASE_URL}/funnel/goals`, publishedXml);

    return data;
};

export const createFunnelWidget = async (funnelId, publishedGraphXML) => {
    const params = new URLSearchParams();

    params.append('funnelId', funnelId);
    params.append('publishedXml', publishedGraphXML);

    const { data } = await axios.post(`${BASE_URL}/konva/reporting/widgets`, params);

    return data;
};
